import { Component, Input, Output, EventEmitter } from '@angular/core';

import { Global } from '../../../../../app.global';
import { Constants } from '../../../helper/constants';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'select-question',
  templateUrl: './select-question.component.html',
})
export class SelectQuestionComponent {
  @Input() data: { title: string };
  @Input() valueSelected: any = 0;
  @Input() active = true;
  @Output() selectAnswer: EventEmitter<any> = new EventEmitter<any>();

  constants = Constants;

  constructor(public global: Global) {}

  onAnswerSelected(value) {
    if (!this.active) {
      return;
    }
    this.selectAnswer.emit(value);
  }
}
